import React from 'react'
import { Link } from 'react-router-dom'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import Footer from '../../components/Footer/Footer';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DownloadIcon from '@mui/icons-material/Download';
// PDF LIsts
import OfertaFile from "../../Assets/Pdf/oferta.pdf"
import Xizmatlar from "../../Assets/Pdf/Xizmatlar.pdf"
import Remont from "../../Assets/Pdf/Remont.pdf"
import Akt from "../../Assets/Pdf/Akt.pdf"
import QaytaOlish from "../../Assets/Pdf/Qayta-olish.pdf"
import AniqlanganXatolar from "../../Assets/Pdf/Aniqlangan-xatolar.pdf"
import VaqtinchalikFoydalanish from "../../Assets/Pdf/Vaqtinchalik-foydalanish.pdf"
import ReestrMalumot from "../../Assets/Pdf/Reestr-malumot.pdf"
import RoyhargaOlish from "../../Assets/Pdf/Royharga-olish.pdf"
import AdressOzgartirish from "../../Assets/Pdf/Adress-ozgartirish.pdf"
function Services() {
  return (
    <>
      <div id='services' className='py-40 bg-[#3C31A2]'>
        <h2 data-aos="zoom-in" className='text-white leading-[50px] sm:leading-normal font-bold text-[50px] text-center'>Публичная оферта</h2>
      </div>
      <div >
        <div className='py-6  bg-[#2F2C3D]'>
          <div className='sm:container px-5 mx-auto flex items-center space-x-1 text-white'>
            <Link className='border-b-2  border-white' to={'/'}>Главный</Link>
            <DoubleArrowIcon style={{ "inlineSize": "20px", "blockSize": "20px" }} />
            <span className='lowercase'>ПУБЛИЧНАЯ ОФЕРТА</span>
          </div>
        </div>
        <div className='bg-[#262431] py-6 sm:py-10'>
          <div className=' container mx-auto flex flex-col lg:flex-row justify-between'>
            <div className='text-white text-[15px] sm:text-[17px] px-5 sm:p-10 flex flex-col space-y-5'>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white hover:text-blue-300 hover:border-blue-300 space-x-3 py-[1.5px] flex justify-between items-center' href={OfertaFile} download={OfertaFile}>
                <span>Оммавий_оферта_шартнома_Тўлиқ</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white hover:text-blue-300 hover:border-blue-300 space-x-3 py-[1.5px] flex justify-between items-center' href={Xizmatlar} download={Xizmatlar}>
                <span>Xizmatlar ro`yxati. Илова № 1</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={Remont} download={Remont}>
                <span>Remont qilish uchun ariza. Илова № 2a</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={Akt} download={Akt}>
                <span>Remont uchun olib qolishga akt. Илова № 2b</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={QaytaOlish} download={QaytaOlish}>
                <span>Remontdan qaytarib olish akt. Илова № 2c</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={AniqlanganXatolar} download={AniqlanganXatolar}>
                <span>Remontga topshirilganda aniqlangan xatoliklar akti. Илова № 3a</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={VaqtinchalikFoydalanish} download={VaqtinchalikFoydalanish}>
                <span>Vaqtinchalik foydalanish uchun akt. Илова № 3b</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={ReestrMalumot} download={ReestrMalumot}>
                <span>Reestr bo`yicha malumotnoma. Илова № 4a</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={RoyhargaOlish} download={RoyhargaOlish}>
                <span>Ro`yxatga olish arizasi. Илова № 4b</span>
                <DownloadIcon />
              </a>
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white space-x-3 hover:text-blue-300 hover:border-blue-300 py-[1.5px] flex justify-between items-center' href={AdressOzgartirish} download={AdressOzgartirish}>
                <span>Adresni o`zgartirish vaqtinchalik yoki polniy o`chirish arizasi. Илова № 5</span>
                <DownloadIcon />
              </a>
            </div>
            <embed
              className='hidden lg:flex'
              src={OfertaFile}
              style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                "blockSize": '1000px',
                'inlineSize': '1000px'
              }}
            />
          </div>
        </div>
      </div>
      <a href={'#services'} className='w-[42px] z-50 rotate-90 duration-200 fixed right-5 bottom-5 h-[42px] text-white flex items-center justify-center rounded-[50%] bg-[#00C9DB] hover:bg-[#73e5f0]'>
        <ArrowBackIosNewIcon />
      </a>
      <Footer bg={true} />
    </>
  )
}

export default Services